module.exports = __webpack_public_path__ + "static/media/SOLDEMEXICO_11mzo.9bcd12e1.jpg";